<div [class.or-mr-8-px]="rightMargin()">
  @if (avatarUrl() && !base64() && !imageFallback()) {
    <ion-avatar [ngClass]="avatarClass()">
      <img
        [ngSrc]="avatarUrl()!"
        [width]="avatarDimension()"
        [height]="avatarDimension()"
        [priority]="priority()"
        [class.avatar-white-border]="showWhiteBorder()"
        [class.custom-avatar-sm-size-with-borders]="showWhiteBorder()"
        (error)="onImageError()" />
    </ion-avatar>
  }
  @if ((!avatarUrl() && initials() && !base64()) || (imageFallback() && initials())) {
    <div
      class="initials-background or-color-main-1"
      [ngClass]="initialsClass()"
      [class.avatar-white-border]="showWhiteBorder()">
      {{ computedInitials() }}
    </div>
  }
  @if (base64() && !avatarUrl() && !initials()) {
    <div [ngClass]="avatarClass()">
      <img [src]="base64()" class="custom-avatar-img" />
    </div>
  }
  @if ((!avatarUrl() && !initials() && !base64()) || (imageFallback() && !initials())) {
    <div [ngClass]="avatarClass()">
      <img src="assets/icons/manual-player-avatar.svg" class="custom-avatar-img" />
    </div>
  }
</div>
